import { useState, useEffect } from 'react'
import { useToast } from '@chakra-ui/react'
import { getPurchaseHistoriesApi } from '@!/Api/storeBookPurchase'
import { isVisibleBook } from '@!/User/Bookshelf/util/Check'
import { useAtom } from 'jotai'
import { userHashAtom } from '@!/atoms/userInfoAtom'

export const usePurchaseHistories = () => {
  const [purchaseHistories, setPurchaseHistories] = useState(null)
  const [userHash] = useAtom(userHashAtom)
  const toast = useToast()

  const fetchPurchaseHistories = async (nextToken = null) => {
    if (!userHash) return

    try {
      const data = await getPurchaseHistoriesApi(nextToken)
      const currentTime = Date.parse(data.current_time)
      const filteredHistories = data.histories.filter((book) => isVisibleBook(book, currentTime))
      setPurchaseHistories((prevState) => ({
        ...prevState,
        ...data,
        histories: prevState ? [...prevState.histories, ...filteredHistories] : filteredHistories,
      }))
      return data
    } catch (error) {
      toast({
        title: 'Notification',
        description: '購入履歴の取得に失敗しました。',
        status: 'error',
        duration: 9000,
        isClosable: true,
      })
      throw error
    }
  }

  useEffect(() => {
    if (userHash) {
      fetchPurchaseHistories()
    }
  }, [userHash])

  return [purchaseHistories, fetchPurchaseHistories]
}
